<template>
    <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
          <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card class="box divider">
          <v-row justify="center" dense>
              <v-col cols="12" sm="3" md="3" class="pt-3">
              <span class="small-text"><b>Academic Year</b></span
              ><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
              <v-autocomplete
                color="#0F2027"
                dense
                required
                v-model="ay"
                item-value="id"
                outlined
                class="mt-1"
                item-color="indigo"
                :items="ay_list"
                item-text="ay"
              />
            </v-col>
            <v-col cols="12" sm="2" md="2" class="pt-10 ml-4 justify-center align-center">
              <v-btn color="primary"  rounded  @click="fetchReport" 
                  >Fetch Report</v-btn>
            </v-col>
          </v-row>
      </v-card>
      <br><br>
      <div class="container-div">
      <employee-appraisal-report v-if="report_flag"></employee-appraisal-report>
    </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import "@/assets/css/color.css";
  import EmployeeAppraisalReport from "./EmployeeAppraisalReport"
  export default {
      components:{
              "employee-appraisal-report": EmployeeAppraisalReport ,            
          },
      data() {
          return {
              snackbar_msg: "",
              color: "",
              snackbar: false,
              overlay: false,
              inst: "",
              ay: "",
              instructor_list: [],
              ay_list: [],
              report_flag: false,
          };
      },
      methods: {
          onLoad() {
              this.overlay = true;
              axios
                  .post("SelfAppriasalMaster/getEmployeeAppraisalReportInitData")
                  .then((res) => {
                      if (res.data.flag === "YES") {
                          this.ay_list = res.data.ay_list;
                          this.instructor_list = res.data.instructor_list;
                          this.ay = res.data.current_ay;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong...");
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong...");
                      console.error(error);
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },
           fetchReport() {
              this.report_flag = false;
              if (!this.ay) {
                  this.showSnackbar("#b71c1c", "Please select Academic Year");
                  return;
              }
              localStorage.setItem("self_authority_id",null)
              localStorage.setItem("ay_id",this.ay)
              this.overlay = false;
              this.$nextTick(() => {
                    this.report_flag = true;
                });
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },
      mounted() {
          this.onLoad();
  
      },
  };
  </script>
  
  <style>
  @media print{
      header,
      footer,
      nav,
      date {
          display: none !important;
      }
      body,
      tr,
      th,
      td {
          font-size: 16px !important;
      }
      .no-display,
      .divider,
      .v-input__control,
      input[type="button"],
      input[type="submit"],
      input[type="reset"],
      #v-card {
          display: none !important;
      }
      .v-card{
          border: none !important;
          box-shadow: none !important;
      }
      
      .toolbar {
          display: block !important;
          visibility: visible !important;
          background: white !important; 
          font-size: 25px !important;
          color: black !important;
      }
      @page {
      size: A4;
      margin: none;
      padding-top: none;
      size: 11.5in 16.5in;
    }
  }
  </style>